import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useQuery, useMutation } from "@apollo/client";
import {
  CREATE_RIGHT,
  UPDATE_RIGHT,
  ALL_MODULES,
} from "../../../data/RoleManagementData"; // Import your GraphQL queries and mutations
import swal from "sweetalert";
import { useState, useEffect } from "react";
import Header from "../../../components/Header";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";
import { allCompanies } from "../../../data/Axios/queries";
import { setupManagementUrl } from "../../../config";
import { executeDynamicSubmit } from "../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const setup_url = setupManagementUrl.uri;

const Form = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const initialValues = {
    name: props.data ? props.data.Name : "",
  };

  const validationSchema = yup.object().shape({
    name: yup.string().required("Name required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    const { name } = values;
    const variables = props.isEditing
      ? { id: props.data.Id, name }
      : { name };

    await executeDynamicSubmit({
      mutationName: props.isEditing ? "updateProducts" : "createProductRepaymentFrequency",
      variables,
      mutationObjectName: "result",
      baseUrl: setup_url,
      isEditing: props.isEditing,
      entityName: "Product Repayment Frequency",
      onSuccess: () => {
        props.onClose();
        props.onAction();
      },
      setSubmitting,
    });
  };

  return (
    <Box m="20px">
      <Header
        title={
          props.isEditing
            ? "Edit Product Repayment  Frequency"
            : "Create Product Repayment  Frequency"
        }
        subtitle={
          props.isEditing
            ? "Edit an Existing Customer Relationship"
            : "Create a New Customer Relationship"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Product Repayment  Frequency*"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
                name="name"
                error={touched.name && !!errors.name}
                helperText={touched.name && errors.name}
                sx={{ gridColumn: "span 2" }}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default Form;